export default "__VITE_ASSET__D4I2BgAL__"